import React, { createContext, PropsWithChildren, useMemo } from 'react';
import { IntlProvider } from 'react-intl';

import { LoadingWrapper } from '@linetweet/linetweet-ui';
import { LocaleKeyEnum } from '../../types';
import { useLocaleSelection } from './useLocaleSelection';
import { useTranslations } from './useTranslations';

export interface ILocaleSelectContext {
  locale: LocaleKeyEnum;
  setLocale: (locale: LocaleKeyEnum) => void;
  resetLocale: () => void;
}

export const LocaleSelectContext = createContext<ILocaleSelectContext | null>(null);

export function LocaleProvider({ children }: PropsWithChildren) {
  const { locale, setLocale, resetLocale } = useLocaleSelection();
  const { messages, loading } = useTranslations(locale);

  const localeSelect: ILocaleSelectContext = useMemo(
    () => ({
      locale,
      setLocale,
      resetLocale,
    }),
    [locale, setLocale, resetLocale],
  );

  return (
    <LocaleSelectContext.Provider value={localeSelect}>
      <IntlProvider
        messages={messages}
        locale="en-US"
        defaultLocale="en-US"
        defaultRichTextElements={{
          // eslint-disable-next-line react/no-unstable-nested-components
          red: (chunks) => (
            <span
              style={{
                color: 'red',
              }}
            >
              {chunks}
            </span>
          ),
          // eslint-disable-next-line react/no-unstable-nested-components
          green: (chunks) => (
            <span
              style={{
                color: 'green',
              }}
            >
              {chunks}
            </span>
          ),
          // eslint-disable-next-line react/no-unstable-nested-components
          br: () => <br />,
        }}
      >
        <LoadingWrapper loading={loading}>
          {children}
        </LoadingWrapper>
      </IntlProvider>
    </LocaleSelectContext.Provider>
  );
}
